import { useEffect, useState } from "react";

import { fn } from "core/util";
import { vehicleChangeApi } from "serverApi/index";
import { Option } from "core/hookForm/components/Field";

export default function useBankCodes() {
    const [isBankCodesFetching, setIsBankCodesFetching] = useState(true);
    const [isFailed, setIsFailed] = useState(false);
    const [bankCodes, setBankCodes] = useState<Option[]>([]);

    useEffect(() => {
        const getBankCodes = async () => {
            const [error, res] = await vehicleChangeApi.getBankCodes();

            if (error) {
                setIsFailed(true);
                setIsBankCodesFetching(false);
                return;
            }

            if (res.ok && res.body) {
                const response = res.body;

                const mappedResponse = response
                    .filter((item) => !fn.isEmpty(item.key) && !fn.isEmpty(item.value))
                    .map((item) => ({
                        code: item.key,
                        value: item.value,
                    }));

                setBankCodes(mappedResponse);
            }

            setIsBankCodesFetching(false);
        };

        getBankCodes();
    }, []);

    return {
        bankCodes,
        isBankCodesFetching,
        isFailed,
    };
}
